module.exports = __webpack_public_path__ + "img/genkidesuka.5ff541df.png";